exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filterDialog_sectionWrapper__3dfYd{max-width:100% !important}", ""]);

// Exports
exports.locals = {
	"sectionWrapper": "filterDialog_sectionWrapper__3dfYd"
};